import { z } from "zod";

export const workspaceSchema = z.object({
  name: z
    .string()
    .trim()
    .min(2, "Workspace-Name muss mindestens 2 Zeichen lang sein")
    .max(100, "Workspace-Name darf maximal 100 Zeichen lang sein")
    .regex(
      /^[a-zA-Z0-9äöüÄÖÜß\s\-_&.,]+$/,
      "Workspace-Name enthält ungültige Zeichen"
    ),
});

export const roleSchema = z.object({
  role: z
    .string()
    .min(1, "Bitte wähle eine Rolle aus"),
  title: z
    .string()
    .trim()
    .max(100, "Titel darf maximal 100 Zeichen lang sein")
    .optional(),
});

export const decisionAreaSchema = z.object({
  decisionType: z
    .string()
    .min(1, "Bitte wähle einen Entscheidungsbereich aus"),
});

export const decisionSubtypeSchema = z.object({
  decisionSubtype: z
    .string()
    .min(1, "Bitte wähle eine spezifische Art der Entscheidung aus"),
});

export const situationSchema = z.object({
  trigger: z
    .string()
    .trim()
    .optional(),
  stakes: z
    .string()
    .trim()
    .optional(),
  previousAttempts: z
    .string()
    .trim()
    .optional(),
  impactScore: z
    .number()
    .min(1, "Impact-Score muss mindestens 1 sein")
    .max(10, "Impact-Score darf maximal 10 sein"),
  urgencyScore: z
    .number()
    .min(1, "Urgency-Score muss mindestens 1 sein")
    .max(10, "Urgency-Score darf maximal 10 sein"),
});

export const situationSchemaQuick = z.object({
  quickContext: z
    .string()
    .trim()
    .min(20, "Bitte beschreibe kurz, was dich beschäftigt (mind. 20 Zeichen)")
    .max(1000, "Bitte halte die Beschreibung unter 1000 Zeichen"),
  impactScore: z
    .number()
    .min(1, "Impact-Score muss mindestens 1 sein")
    .max(10, "Impact-Score darf maximal 10 sein"),
  urgencyScore: z
    .number()
    .min(1, "Urgency-Score muss mindestens 1 sein")
    .max(10, "Urgency-Score darf maximal 10 sein"),
});

export type WorkspaceFormData = z.infer<typeof workspaceSchema>;
export type RoleFormData = z.infer<typeof roleSchema>;
export type DecisionAreaFormData = z.infer<typeof decisionAreaSchema>;
export type DecisionSubtypeFormData = z.infer<typeof decisionSubtypeSchema>;
export type SituationFormData = z.infer<typeof situationSchema>;
export type SituationQuickFormData = z.infer<typeof situationSchemaQuick>;
